module.exports = __webpack_public_path__ + "5a372ee5044fc6991aaffe4dffc853d1.png";